export const authSetTags = (tags) => {
	return {
		type: 'AUTH_SET_TAGS',
		tags
	};
};

export const authSetModules = (modules) => {
	return {
		type: 'AUTH_SET_MODULES',
		modules
	};
};
export const authSetMenu = (menu) => {
	return {
		type: 'AUTH_SET_MENU',
		menu
	};
};

export const authSetRoles = (roles) => {
	return {
		type: 'AUTH_SET_ROLES',
		roles
	};
};

export const authSetLicense = (license) => {
	return {
		type: 'AUTH_SET_LICENSE',
		license
	};
};

export const authUnset = () => {
	return {
		type: 'AUTH_UNSET'
	};
};
export const authSetLoggedIn = (loggedIn) => {
	return {
		type: 'AUTH_SET_LOGGED_IN',
		loggedIn
	};
};
